export default __webpack_public_path__ + "6df7c7cab824b22f747b7dec23e4597e.png";